import { size } from '@shared/utils/breakpoints';
import styled from 'styled-components';

export const HolidayHeading = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 40px;
  `

export const TabHeader = styled.div`
    width: 100%;
    color: #000;

    margin-bottom: 50px;

    /* Large Screens/Headings/H5 */
    font-size: 28.13px;
    font-style: normal;
    font-weight: 400;
    line-height: 114%; /* 32.068px */
  `

export const TabWrapper = styled.div`

    display: flex;
    flex-direction: row;
    gap: 12px;
    margin-bottom: 120px;

    ${`@media (max-width: ${size.medium}) {
      flex-direction: column;
      margin-bottom: 48px;


    }`}

    `

export const HolidayTitle = styled.h2`
  font-size: 55px;
  font-weight: 400px;

  @media (max-width: ${size.medium}) {
  font-size: 32px;
  }



  `

export const HolidayBanner = styled.div`
  height: 202px;
  background: url('https://phmg-styles.s3.eu-west-2.amazonaws.com/images/HolidayCampaignBg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  border-radius: 12px;
  margin-bottom: 120px;
  padding: 24px 26px;
  display: flex;
  flex-direction: column;

  @media (max-width: ${size.medium}) {
  padding-top: 40px;
  margin-bottom: 64px;
  }

  `

export const BannerTitle = styled.h4`
    font-size: 35px;
    color: white;

    @media (max-width: ${size.medium}) {
    font-size: 24px;
    }

  `

export const BannerSubtitle = styled.h2`
  color: #00242E;
  font-size: 54.94px
  font-style: normal;
  font-weight: 300;
  line-height: 114%;



  @media (max-width: ${size.medium}) {
  font-size: 24px;
  }

  `

export const BannerText = styled.p`

  font-size:22px;
  color: white;
  margin-top: 8px;

  @media (max-width: ${size.medium}) {
  font-size: 16px;
  }

`

export const BannerActions = styled.a`
  border-radius: 999px;
  color: white;
  border: 2px solid #FFF;
  background: rgba(255, 255, 255, 0.00);
  padding: 12px 28px;
  width: 167px;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  fill: white;
  &:hover {
    border: 2px solid black;
    cursor: pointer;
    background: white;
    fill: black !important;
    color: black !important;
  }
`

export const ActionText = styled.p`


  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%
  `

export const Heading = styled.div`
  margin: 20px 0;
`;

export const PageWrapper = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 104px;
  background: radial-gradient(35.2% 34.84% at 3.53% -6.11%, rgba(235, 23, 0, 0.40) 0%, rgba(235, 23, 0, 0.00) 100%), radial-gradient(36.44% 30.41% at 36.04% -4.61%, rgba(139, 216, 239, 0.60) 0%, rgba(139, 216, 239, 0.00) 100%), radial-gradient(40.02% 31.26% at 59.69% -0.53%, rgba(223, 166, 235, 0.60) 0%, rgba(223, 166, 235, 0.00) 100%), radial-gradient(59.05% 32.92% at 86.91% -4.32%, rgba(255, 168, 0, 0.60) 0%, rgba(255, 168, 0, 0.00) 100%);

  @media (max-width: ${size.medium}) {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 40px;
  }

  `;

export const Title = styled.h2`

  font-weight: 600;


  `

export const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 80px;
  width: 100%;

  & > div {
    flex-basis: 100%;
  }

  @media (min-width: ${size.medium}) {
    flex-direction: row;
    & > div {
      flex-basis: 48%;
    }
  }

  @media (min-width: ${size.slightlyLarger}) {
    gap: 15px;
    & > div {
      max-width: 370px;
    }
  }
`;
